import React from 'react';

import './LoginAccessNotice.scss';

const METHOD_COPY = {
  totp: 'een authenticator-app',
  email: 'een code per e-mail',
  sms: 'een code per sms'
};

export function careRecordsLocked(user) {
  return user?.mfaEnforced === true && user?.mfaVerified === false;
}

export function LoginSessionBar({ user, loginUrl, layout = 'dashboard' }) {
  if (typeof user?.mfaVerified !== 'boolean') return null;

  const verified = user.mfaVerified;
  const method = METHOD_COPY[user.mfaMethod];
  const text = verified
    ? method
      ? `Ingelogd met tweestapsverificatie via ${method}.`
      : 'Ingelogd met tweestapsverificatie.'
    : 'Ingelogd met je wachtwoord, zonder tweestapsverificatie.';

  return (
    <p className={`_loginSessionBar ${layout} ${verified ? 'is-verified' : 'is-password'}`}>
      <span>{text}</span>
      {!verified && (
        <a className="_loginSessionBar-link" href={mfaSettingsUrl(loginUrl)}>
          Aanzetten
        </a>
      )}
    </p>
  );
}

export default function LoginAccessNotice({ user, loginUrl, tone = 'status' }) {
  if (user?.mfaEnforced !== true) return null;
  if (typeof user?.mfaVerified !== 'boolean') return null;
  if (user.mfaVerified && tone === 'care') return null;

  const verified = user.mfaVerified;
  const method = METHOD_COPY[user.mfaMethod] || 'een extra verificatiestap';

  const heading = verified
    ? 'Je bent ingelogd met tweestapsverificatie'
    : tone === 'care'
      ? 'Tweestapsverificatie nodig voor je zorggegevens'
      : 'Je bent ingelogd met je wachtwoord';

  const message = verified
    ? `Deze sessie is bevestigd met ${method}. Daarmee kun je je dossier, afspraken en documenten openen.`
    : tone === 'care'
      ? 'Je bent ingelogd met je wachtwoord. Je dossier, afspraken en documenten blijven afgeschermd tot je tweestapsverificatie aanzet en opnieuw inlogt.'
      : 'Dat is genoeg om rond te kijken. Voor je dossier, afspraken en documenten zet je tweestapsverificatie aan. Log daarna opnieuw in, dan geldt het ook voor deze sessie.';

  return (
    <section className={`_loginAccessNotice ${verified ? 'is-verified' : 'is-password'}`}>
      <h2 className="_loginAccessNotice-heading">{heading}</h2>
      <p className="_loginAccessNotice-message">{message}</p>
      {!verified && (
        <a className="_loginAccessNotice-link" href={mfaSettingsUrl(loginUrl)}>
          Tweestapsverificatie aanzetten
        </a>
      )}
    </section>
  );
}

function mfaSettingsUrl(loginUrl) {
  try {
    return new URL('/portal/mfa', loginUrl).href;
  } catch (e) {
    return 'https://id.zwangerenportaal.nl/portal/mfa';
  }
}
